import { useRouter } from 'next/router';
import { usePartnersProfilePath } from '@utils/usePartnersProfileUrl';

export const marketplacePath = 'https://www.wix.com/marketplace';

export const explorePath =
  process.env.NODE_ENV === 'production' ? '/marketplace/hire' : '/hire';

export const projectsPath =
  process.env.NODE_ENV === 'production'
    ? '/marketplace/my-projects'
    : '/my-projects';

export const briefAutoMatchPath =
  process.env.NODE_ENV === 'production'
    ? '/marketplace/brief-auto-match'
    : '/brief-auto-match';

export const templatesPath =
  process.env.NODE_ENV === 'production'
    ? '/marketplace/templates'
    : '/templates';

export { templatesFavoritesPath } from '@utils/urlUtils';

export const templatePath =
  process.env.NODE_ENV === 'production' ? '/marketplace/template' : '/template';

export const viewListingPath = 'listing';
export const viewTemplatePath =
  process.env.NODE_ENV === 'production'
    ? `/marketplace/template/view/${viewListingPath}`
    : `/template/view/${viewListingPath}`;

export const useShallowRouter = () => {
  const router = useRouter();
  const { pathname } = router;
  const profilePath = usePartnersProfilePath();

  const navigate = (params: string, keepPathParams: boolean = true): void => {
    if (pathname.includes('partners')) {
      const { slug } = router.query;
      router.replace(`${profilePath}/${slug}${params}`, undefined, {
        shallow: true,
      });
    } else if (pathname.includes('my-projects')) {
      router.replace(`${projectsPath}/${params}`, undefined, {
        shallow: true,
      });
    } else if (pathname.includes('templates')) {
      const { all } = router.query;
      const pathParams = all && all.length > 0 ? all : [];
      const platformParam = pathParams[0];
      const pathName = keepPathParams
        ? `${platformParam ? `/${platformParam}` : ''}`
        : '';
      router.push(`${templatesPath}${pathName}${params}`, undefined, {
        shallow: true,
      });
    } else {
      const { all } = router.query;
      const pair = all && all.length > 0 ? all : [];
      const categoryName = pair[0];
      const serviceName = pair[1];
      const pathName = keepPathParams
        ? params.includes('serviceIds')
          ? ''
          : `${categoryName ? `/${categoryName}` : ''}${
              serviceName ? `/${serviceName}` : ''
            }`
        : '';
      router.push(`${explorePath}${pathName}${params}`, undefined, {
        shallow: true,
      });
    }
  };
  const routerPushShallow = (pathName: string) =>
    router.push(pathName, undefined, {
      shallow: true,
    });

  return { navigate, routerPushShallow, router };
};
